import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=4fe10587&"
import script from "./ClassList.vue?vue&type=script&lang=ts&"
export * from "./ClassList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports